import React from 'react';
import { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { P } from '../../AbstractElements';

const Footer = () => {
  const getYear = () => {
    return new Date().getFullYear();
  }
  return (
    <Fragment>
      <footer className="footer">
      </footer>
    </Fragment>
  );
};

export default Footer;